module.exports = __webpack_public_path__ + "static/img/3.2fd39e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/pharmacy/3/3.png
// module id = oxA6
// module chunks = 1